import React from "react";

import {
  IgCoreBackgroundColors,
  IgCoreTextColors,
  IgIconColors,
} from "@intelligems/ig-design-tokens";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * @see Tooltip
 */

type IgTooltipProps = Omit<TooltipProps, "children"> & {
  children?: React.ReactNode;
  maxWidth?: string | number;
  /** Styles for the wrapper `<span>`. `lineHeight: 0` is enforced and cannot be overridden. */
  wrapperStyle?: React.CSSProperties;
};

export const IgTooltip = styled(
  ({
    maxWidth,
    className,
    slotProps,
    wrapperStyle,
    ...props
  }: IgTooltipProps) => (
    <Tooltip
      slotProps={{
        arrow: { sx: { color: IgIconColors.light } },
        ...slotProps,
      }}
      arrow
      {...props}
      classes={{ popper: className }}
    >
      <span style={{ ...wrapperStyle, lineHeight: 0 }}>{props.children}</span>
    </Tooltip>
  )
)(({ maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth,
    backgroundColor: IgCoreBackgroundColors.interactive.dark.default,
    "& .MuiTypography-root": {
      color: IgCoreTextColors.dark,
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
}));
